
import { AbhyasaBharathiMagazine } from "../schoolPrograms/abhyasaBharathi/abhyasaBharathi";
import { Facilitator } from "./facilitator";


export const FacilitatorAbhyasaBharathi = () => {

    return (<>
        <Facilitator>
           <AbhyasaBharathiMagazine isAddFilesVisible={true} isDeleteFilesVisible={true} />

        </Facilitator>
    </>);
}